import { render } from "./NeedToHeatingOfLenta.vue?vue&type=template&id=77b0e56e&scoped=true"
import script from "./NeedToHeatingOfLenta.vue?vue&type=script&lang=js"
export * from "./NeedToHeatingOfLenta.vue?vue&type=script&lang=js"

import "./NeedToHeatingOfLenta.vue?vue&type=style&index=0&id=77b0e56e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b0e56e"]])

export default __exports__